// import Vue from "vue";
import { createApp } from 'vue'
import i18next from "i18next";
import I18NextVue from "i18next-vue";
import App from "./App.vue";
import messages from './lang/lang'

// Default kiosk languages. Any extra language configured for the company
// in admin is merged on top at runtime (see getBanner in sharedFunction.js).
window.allLang = ['ro', 'en'];

// Register every language that has UI strings in lang.js (en, es, el, it, de, ro, hu, ...).
// Adding a new block in lang.js is enough for it to work here automatically.
const resources = {};
Object.keys(messages).forEach((lng) => {
	resources[lng] = { translation: messages[lng] };
});

const i18nInitialized = i18next.init({
	lng: 'ro', // sets a default language. Note that if this option is not set, I18next will try to perform language detection automatically and set the locale accordingly
	fallbackLng: 'ro', //says which locale data to use if translations for the currently set language is unavailable
	// No whitelist: extra admin languages are allowed for product/category names;
	// UI strings without a bundled translation gracefully fall back to 'ro'.
	resources: resources,
});

i18nInitialized.then(() => createApp(App).use(I18NextVue, { i18next }).mount('#app'));
